import { Suspense } from "react";
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate
} from "react-router-dom"

import GlobalLoading from "../components/common/loading/GlobalLoading";
import Dashboard from "./dashboard/Dashboard";
import Profile from "./profile/Profile";
import Login from "./Login";
import {useSetAxiosHeaders} from "../core/hooks/common/useSettings";
import MainLayout from "../components/layout/main/MainLayout";
import Users from "./users/Users";
import AclContextProvider from "../core/contexts/acl";
import Affiliates from "./reports/affiliates/Affiliates";
import Tokens from "./setting/tokens/Tokens";
import Pairs from "./setting/pairs/Pairs";
import Roles from "./setting/roles/Roles";
import Robots from "./setting/robots/Robots";
import Otc from "./setting/otc/Otc";
import General from "./setting/general/General";
import UserDetails from "./users/UserDetails";
import Reports from "./reports";
import AffiliateReport from "./reports/affiliates/AffiliateReport";
import Settings from "./setting";
import TokenDetails from "./setting/tokens/TokenDetails";
import TokenOperation from "./setting/tokens/TokenOperation";
import UserLevels from "./setting/user-levels/UserLevels";
import Fiat from "./setting/fiat/Fiat";
import OtcSettingDetails from "./setting/otc/OtcSettingDetails";
import AddUser from "./users/AddUser";
import Addresses from "./reports/address/Addresses";
import UserSubDetails from "./users/UserSubDetails";
import {useMainContext} from "../core/contexts/main";
import Currencies from "./setting/currencies/Currencies";
import Workspace from "./reports/workspace/Workspace";
import WorkspaceDetails from "./reports/workspace/WorkspaceDetails";
import Payment from "./reports/payment/Payment";
import PaymentDetails from "./reports/payment/PaymentDetails";
import TraceMain from "./reports/trace/TraceMain";
import WalletTransactions from "./reports/wallet-transactions/WalletTransactions";
import WalletTransactionDetails from "./reports/wallet-transactions/WalletTransactionDetails";
import TransactionDetails from "./reports/transactions/TransactionDetails";
import Transactions from "./reports/transactions/Transactions";
import Repositories from "./reports/repositories/Repositories";
import Cartable from "./cartable/Cartable";
import CartableDetails from "./cartable/CartableDetails";



const Index = () => {

    // setting headers
    useSetAxiosHeaders()
    const { token } = useMainContext()

    return (
        <AclContextProvider>
            <Router basename={process.env.PUBLIC_URL}>
                <Suspense fallback={<GlobalLoading />}>
                    <MainLayout>
                        {!!token ?
                            <Routes>
                                {routes.map(route => {

                                    const {path, Component} = route
                                    return <Route key={path} path={path} element={<Component />} />
                                })}
                                <Route path={'*'}  element={<Navigate to="/profile" replace />} />
                            </Routes>
                            :
                            <Routes>
                                <Route key={'login'} path={'/login'} element={<Login />} />
                                <Route path={'*'}  element={<Navigate to="/login" replace />} />
                            </Routes>
                        }

                    </MainLayout>
                </Suspense>
            </Router>
        </AclContextProvider>
    )
}


export const routes = [
    { path: '/dashboard', Component: Dashboard },

    { path: '/profile', Component: Profile},
    { path: '/profile/:id', Component: UserDetails},
    { path: '/profile/:id/:tab', Component: UserDetails},
    { path: '/profile/:id/:tab/:detailId', Component: UserSubDetails },

    { path: '/cartable', Component: Cartable },
    { path: '/cartable/:id', Component: CartableDetails },

    { path: '/users', Component: Users},
    { path: '/users/:id', Component: UserDetails},
    { path: '/users/:id/:tab', Component: UserDetails},
    { path: '/users/:id/:tab/:detailId', Component: UserSubDetails },
    { path: '/users/add-user', Component: AddUser},

    { path: '/reports', Component: Reports},

    { path: '/reports/businesses', Component: Workspace },
    { path: '/reports/businesses/:id', Component: WorkspaceDetails },

    { path: '/reports/wallet-transactions', Component: WalletTransactions },
    { path: '/reports/wallet-transactions/:id', Component: WalletTransactionDetails },

    { path: '/reports/payment', Component: Payment },
    { path: '/reports/payment/:id', Component: PaymentDetails },

    { path: '/reports/affiliate-overview', Component: Affiliates},
    { path: '/reports/affiliate-overview/:id', Component: AffiliateReport},

    { path: '/reports/addresses', Component: Addresses},

    { path: '/reports/trace', Component: TraceMain },

    { path: '/reports/transactions', Component: Transactions },
    { path: '/reports/transactions/:id', Component: TransactionDetails },

    { path: '/reports/repositories' , Component: Repositories },

    { path: '/setting', Component: Settings },

    { path: '/setting/tokens', Component: Tokens },
    { path: '/setting/tokens/:id', Component: TokenDetails },
    { path: '/setting/tokens/operation', Component: TokenOperation },

    { path: '/setting/wages', Component: Fiat },

    { path: '/setting/otc', Component: Otc },
    { path: '/setting/otc/details', Component: OtcSettingDetails },

    { path: '/setting/pairs', Component: Pairs },
    { path: '/setting/roles', Component: Roles },
    { path: '/setting/robots', Component: Robots },
    { path: '/setting/user-levels', Component: UserLevels },
    { path: '/setting/currencies', Component: Currencies },
    { path: '/setting/general', Component: General },



]


export default Index;
